import { render } from "./SizeDialog.vue?vue&type=template&id=9b65ff78"
import script from "./SizeDialog.vue?vue&type=script&lang=js"
export * from "./SizeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__